import {RenovationKeyEnum} from "../enums/renovation-key.enum";
import {RenovationLabelEnum} from "../enums/renovation-label.enum";
import {RenovationValueEnum} from "../enums/renovation-value.enum";

export const RENOVATIONS = [
	{
		key: RenovationKeyEnum.COMPLETE,
		label: RenovationLabelEnum.COMPLETE,
		value: RenovationValueEnum.COMPLETE
	},
	{
		key: RenovationKeyEnum.REFRESH,
		label: RenovationLabelEnum.REFRESH,
		value: RenovationValueEnum.REFRESH
	},
	{
		key: RenovationKeyEnum.ENERGIE,
		label: RenovationLabelEnum.ENERGIE,
		value: RenovationValueEnum.ENERGIE
	},
	{
		key: RenovationKeyEnum.TOTALE,
		label: RenovationLabelEnum.TOTALE,
		value: RenovationValueEnum.TOTALE
	}
] as const;

export type RenovationKey = typeof RENOVATIONS[number]['key'];

export const RENOVATION_MAP: Record<RenovationKey, string> = RENOVATIONS.reduce((acc, r) => {
	acc[r.key] = r.label;
	return acc;
}, {} as Record<RenovationKey, string>);

export const RENOVATION_VALUE_MAP: Record<RenovationKey, number> = RENOVATIONS.reduce((acc, r) => {
	acc[r.key] = r.value;
	return acc;
}, {} as Record<RenovationKey, number>);
